import { NumberRangeFilterValidationResult } from '~/components/organisms/filters/numberRangeFilter/NumberRangeFilter';
import { ErrorMessagesNumberRangeFilter } from '~/utils/errors/errorMessages';

const validateNumberRangeFilterStateChange = (
    min: number,
    max: number,
    initialMin: number,
    initialMax: number,
    changedValue: 'min' | 'max' | 'both'
): NumberRangeFilterValidationResult => {
    if (initialMin > initialMax) {
        throw new Error(ErrorMessagesNumberRangeFilter.INTEGER_FILTER_MIN_GREATER_MAX);
    }
    if (changedValue === 'both') {
        if (isNaN(min) || isNaN(max)) {
            return {
                newMin: initialMin,
                newMax: initialMax,
            };
        }

        if (min > max) {
            return {
                newMin: initialMin,
                newMax: initialMax,
            };
        }

        if (min < initialMin && max > initialMax) {
            return {
                newMin: initialMin,
                newMax: initialMax,
            };
        }

        if (min < initialMin) {
            return {
                newMin: initialMin,
                newMax: max,
            };
        }

        if (max > initialMax) {
            return {
                newMin: min,
                newMax: initialMax,
            };
        }
    }

    if (changedValue === 'min') {
        if (isNaN(min)) {
            return {
                newMin: initialMin,
                newMax: max,
            };
        }

        if (min < initialMin) {
            return {
                newMin: initialMin,
                newMax: max,
            };
        }

        if (min > max) {
            return {
                newMin: max,
                newMax: max,
            };
        }
    }

    if (changedValue === 'max') {
        if (isNaN(max)) {
            return {
                newMin: min,
                newMax: initialMax,
            };
        }

        if (max > initialMax) {
            return {
                newMin: min,
                newMax: initialMax,
            };
        }

        if (max < min) {
            return {
                newMin: min,
                newMax: min,
            };
        }
    }

    return {
        newMin: min,
        newMax: max,
    };
};

export default validateNumberRangeFilterStateChange;
